module.exports = __webpack_public_path__ + "static/media/vf_mouter_core.30c48ad2.svg";